import styled, { css } from "styled-components";
import {
  StyledButton,
  StyledButtonLink,
} from "../Button/Button.styled";
import { deviceMax } from "../../../utils/device";

interface IPlanWrapper {
  featured?: boolean;
}

export const PlanWrapper = styled.article<IPlanWrapper>(
  ({ theme, featured }) => css`
    background: ${theme.colors.white};
    border: 1px solid ${theme.colors.brand.line};
    border-radius: ${theme.layout.radius.card};
    display: flex;
    flex-direction: column;
    padding: 28px 28px 26px;
    position: relative;

    ${featured &&
    css`
      background: linear-gradient(
            ${theme.colors.white},
            ${theme.colors.white}
          )
          padding-box,
        ${theme.gradients.brand} border-box;
      border: 2px solid transparent;
      box-shadow: 0 10px 25px rgba(56, 77, 112, 0.06);
      padding: 27px 27px 25px;
    `};

    ${StyledButton}, ${StyledButtonLink} {
      font-size: 12px;
      margin-top: auto;
      min-height: 44px;
    }

    @media ${deviceMax.desktopSMax} {
      padding: ${featured ? "24px" : "25px"};
    }

    @media ${deviceMax.tabletWideMax} {
      padding: ${featured ? "21px 19px" : "22px 20px"};
    }

    @media ${deviceMax.phoneMax} {
      padding: 26px;

      ${StyledButton}, ${StyledButtonLink} {
        font-size: 13px;
        min-height: 46px;
      }
    }
  `
);

export const PlanKicker = styled.div<IPlanWrapper>(
  ({ theme, featured }) => css`
    color: ${featured ? "#8B359B" : "#6B788A"};
    font-size: 10px;
    font-weight: ${theme.typography.weights.bold};
    height: 18px;
    letter-spacing: 0.1em;
    margin-bottom: 15px;
    text-transform: uppercase;

    @media ${deviceMax.phoneMax} {
      height: auto;
      margin-bottom: 11px;
    }
  `
);

export const PlanName = styled.h3(
  ({ theme }) => css`
    font-family: ${theme.typography.fonts.display};
    font-size: 20px;
    font-weight: 650;
    letter-spacing: -0.035em;
    line-height: 1.3;
    margin: 0 0 18px;

    @media ${deviceMax.desktopSMax} {
      font-size: 18px;
    }

    @media ${deviceMax.tabletWideMax} {
      font-size: 16px;
    }

    @media ${deviceMax.phoneMax} {
      font-size: 22px;
      margin-bottom: 13px;
    }
  `
);

export const PriceLine = styled.div`
  align-items: baseline;
  display: flex;
  gap: 9px;
  margin-bottom: 10px;
`;

export const PriceNumber = styled.strong(
  ({ theme }) => css`
    font-family: ${theme.typography.fonts.display};
    font-size: 46px;
    font-weight: 650;
    letter-spacing: -0.05em;
    line-height: 1.2;

    @media ${deviceMax.tabletWideMax} {
      font-size: 40px;
    }

    @media ${deviceMax.phoneMax} {
      font-size: 47px;
    }
  `
);

export const PriceUnit = styled.span`
  color: #68778b;
  font-size: 12px;
`;

export const PlanDescription = styled.p`
  color: ${({ theme }) => theme.colors.brand.muted};
  font-size: 12px;
  line-height: 1.7;
  margin: 0;
  min-height: 44px;

  @media ${deviceMax.tabletWideMax} {
    font-size: 11px;
  }

  @media ${deviceMax.phoneMax} {
    font-size: 13px;
    min-height: 0;
  }
`;

export const PlanList = styled.ul`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  gap: 12px;
  list-style: none;
  margin: 25px 0 27px;
  padding: 0;

  li {
    align-items: flex-start;
    display: flex;
    gap: 10px;
  }

  svg {
    color: #4d687d;
    height: 15px;
    margin-top: 2px;
    width: 15px;
  }

  @media ${deviceMax.tabletWideMax} {
    font-size: 11px;
  }

  @media ${deviceMax.phoneMax} {
    font-size: 13px;
    margin: 23px 0 25px;

    svg {
      height: 16px;
      width: 16px;
    }
  }
`;

export const PlanNote = styled.p(
  ({ theme }) => css`
    border-top: 1px solid ${theme.colors.brand.line};
    color: #65768a;
    font-size: 10px;
    line-height: 1.6;
    margin: 0 0 22px;
    padding-top: 14px;

    @media ${deviceMax.phoneMax} {
      font-size: 11px;
      margin-bottom: 20px;
    }
  `
);
